import React from 'react'
import {
  useCheckoutFormBillingState,
  useLocalLabels,
  useGlobalLabels,
} from '@sentecacommerce-theme/lib'
import {
  Button,
  IconPlus,
  BillingAddressPreview,
  InputLabel as Label,
  Checkbox,
  FormError,
} from '../../../Common'
import { CheckoutLabels } from '../../checkout.props'
import styled from 'styled-components'
import { CheckoutInvoiceForm } from './Components'

export const Invoice = () => {
  const {
    isAddingNew,
    updateIsAddingNew,
    isWithBillingAddress,
    updateIsWithBillingAddress,
    billingAddressList,
    canSaveBillingAddress,
    saveBillingAddress,
    isSubmitting,
    isValid,
  } = useCheckoutFormBillingState()

  const labels = useLocalLabels<CheckoutLabels>()
  const { cancel } = useGlobalLabels()

  const hasCompanies = Boolean(billingAddressList?.length)

  const isSelectingCompany = !isAddingNew && hasCompanies

  return (
    <InputsWrapper>
      <div className="col-12">
        <Label htmlFor="" className="mb-2">
          <Checkbox
            label={labels?.withInvoiceLabel}
            isChecked={Boolean(isWithBillingAddress)}
            onChange={() => {
              updateIsWithBillingAddress(!isWithBillingAddress)
            }}
            style={{ bottom: '0.1rem' }}
          />
        </Label>
      </div>

      {isWithBillingAddress && !isSelectingCompany && (
        <>
          <CheckoutInvoiceForm />
          {canSaveBillingAddress && (
            <div className="col-12">
              <div className="d-flex align-items-center">
                {Boolean(hasCompanies) && (
                  <div className="mr-3">
                    <Button
                      variant="light"
                      bordered
                      small
                      type="button"
                      onClick={() => updateIsAddingNew(false)}
                      borderRadius="small"
                    >
                      <span className="d-flex align-items-center">
                        <span>{cancel}</span>
                      </span>
                    </Button>
                  </div>
                )}
                <Button
                  variant="green"
                  small
                  type="button"
                  onClick={() => saveBillingAddress()}
                  borderRadius="small"
                >
                  <span className="d-flex align-items-center">
                    <span>{labels?.saveTheCompanyData}</span>
                  </span>
                </Button>
              </div>
            </div>
          )}
        </>
      )}

      {isWithBillingAddress && isSelectingCompany && (
        <>
          <div className="col-12">
            {billingAddressList?.map((address, index) => (
              <div key={address._id || index} className="pb-4">
                <BillingAddressPreview
                  data={address as any}
                  isSelectable
                  isSelected={address.isSelected}
                  onChange={address.select}
                  hideRemove
                  labels={{
                    editLabel: labels?.editLabel,
                    primaryCompanyLabel: labels?.primaryCompanyLabel,
                  }}
                />
              </div>
            ))}
            {!isValid && isSubmitting && (
              <FormError text={labels?.validations?.saveOrAddNewCompany} />
            )}
          </div>
          <div className="col-12">
            <Button
              className="mt-4"
              variant="primary"
              bordered
              // small
              onClick={(e: any) => {
                e.preventDefault()
                updateIsAddingNew(true)
              }}
              borderRadius="small"
            >
              <span className="d-flex align-items-center">
                <IconPlus width="1.5rem" className="mr-3" />
                <span>{labels?.addNewCompanyLabel}</span>
              </span>
            </Button>
          </div>
        </>
      )}
    </InputsWrapper>
  )
}

const InputsWrapper = styled.div.attrs({
  className: 'row',
})`
  & button {
  }
`
